import React from 'react';
import { IconSizes } from '@newcore/icons';
import { Spinner } from '@newcore/ui/loading';
import { Onboarding } from '@/features/onboarding/components/primitives';

/**
 * Exchanging state UI for CompleteStep
 * Shows loading spinner while JWT exchange is in progress
 */
export const CompleteStepExchanging: React.FC = (): React.ReactElement => {
  return (
    <div className='flex flex-col items-center text-center space-y-6 py-4'>
      <div className='flex items-center justify-center h-20 w-20'>
        <Spinner size={IconSizes.LG} className='text-primary' />
      </div>
      <div className='space-y-2'>
        <Onboarding.Title>Finishing setup...</Onboarding.Title>
        <Onboarding.Description>Securing your session</Onboarding.Description>
      </div>
    </div>
  );
};
